import React from "react";
import "../styles/UserList.css"; // Optional, or extract to UserList.css
import { isValidPhotoUrl } from "../utils/validationUtils";
import { getInitials } from "../utils/stringUtils";
// Memoize the UserList component to prevent unnecessary re-renders
const UserList = React.memo(({ users, activeUserId, onUserSelect, onUserInfoClick }) => {
  if (users.length === 0) {
    return <ul className="user-list"><li className="no-results">No users found</li></ul>;
  }
  
  return (
    <ul className="user-list">
      {users.map((user) => (
        <li
          key={user.id}
          className={`user-item ${user.id === activeUserId ? "active" : ""}`}
          onClick={() => onUserSelect(user.id)}
        >
          <div className="user-avatar">
                  {user.photo && isValidPhotoUrl(user.photo) ? (
              <img src={user.photo} alt={user.name} />
            ) : (
                          <div className="user-initials-circle">
                              {getInitials(user.name)}
              </div>
            )}
          </div>
          <div>
            <div className="user-name">{user.name}</div>
            <div className="last-message">
              {user.lastMessageText || "No messages yet"}
            </div>
          </div>
          {user.unreadCount > 0 && (
            <div className="unread-count">
              {user.unreadCount > 99 ? "99+" : user.unreadCount}
            </div>
          )}
          <div
            className="info-icon"
            onClick={(e) => {
              e.stopPropagation(); // Prevent triggering onUserSelect
              onUserInfoClick(user);
            }}
          >
            ℹ️
          </div>
        </li>
      ))}
    </ul>
  );
});

// Set the display name for better debugging and DevTools usage
UserList.displayName = "UserList";

export default UserList;
